var ModalManager = (function () {

    /** @description Set the modal title
     * @param {string} title Text to apply to the modal
     * @param {string} modalIdentifier Class or ID of the modal, include either # or .
     */
    function ReplaceHead(title, modalIdentifier) {
        $(modalIdentifier)
            .find('.modal-title')
            .html('<h4>' + title + '</h4>');
    }

    function ReplaceBody(body, modalIdentifier) {
        $(modalIdentifier)
            .find('.modal-body')
            .html('<p>' + body + '</p>');
    }

    function ShowModal(title, body, modalIdentifier) {
        ReplaceHead(title, modalIdentifier);
        ReplaceBody(body, modalIdentifier);
        $(modalIdentifier).modal();
    }

    function HideModal(modalIdentifier) {
        $(modalIdentifier).modal('hide');
    }

    function setModalValues(values, modalIdentifier) {

        $.each(values, function (i, e) {
            var input = $(modalIdentifier + ' #' + i);

            if (input.hasClass('chosen-select')) {
                input
                    .val(e.split(';'))
                    .trigger("chosen:updated");
            }
            else if (input.length > 0 && input[0].type === 'checkbox') {
                input
                    .prop('checked', e)
                    .change();
            } else {
                input.val(e);
            }
        });
    }

    // Hide all elements with the hideOn data attribute set to type
    function hideFields(modalIdentifier, type) {
        var elements = $(modalIdentifier).find('[data-hideOn]');

        elements.each(function () {
            var element = $(this);
            var x = [];
            var data = element.data('hideon');

            if (Array.isArray(data))
                x = data;
            else
                x.push(data);

            for (var i = 0; i < x.length; i++) {
                if (type.indexOf(x[i]) >= 0)
                    element.hide();
            }
        });
    }

    // Disable all elements with the disableOn data attribute set to type
    function disableFields(modalIdentifier, type) {
        $.each(type, function (i, e) {
            var element = $(modalIdentifier).find('[data-disableOn=' + e + ']');

            element
                .prop('disabled', 'disabled')
                .trigger("chosen:updated");
        });
    }

    function reset() {
        $form = $('.modal form');

        //$('.modal').modal('hide');

        $('.modal').find('[data-hideOn]').show();
        $form.find('[data-disableOn]').prop('disabled', false);
        
        $form.find(':input').not(':checkbox, :radio, select').val('');
        $form.find('.chosen-select').val([]);
        $form.find('select').not('.chosen-select').prop('selectedIndex', 0);
        $form.find(':checkbox, :radio').prop('checked', false).change();
        $form.find('.chosen-select').trigger("chosen:updated");
    }

    $(document).on('hide.bs.modal', '.modal', function (e) {
        reset();
    });

    return {
        ShowMessage: function (title, body, modalIdentifier) {
            modalIdentifier = typeof modalIdentifier === 'undefined' ? '#messages' : modalIdentifier;
            ShowModal(title, body, modalIdentifier);
        },

        Show: function (modalIdentifier, type, title) {
            $(modalIdentifier).addClass(type);
            hideFields(modalIdentifier, type);
            disableFields(modalIdentifier, type);
            ReplaceHead(title, modalIdentifier);
            $(modalIdentifier).modal();
        },

        Hide: function (modalIdentifier) {
            modalIdentifier = typeof modalIdentifier === 'undefined' ? '#messages' : modalIdentifier;
            HideModal(modalIdentifier);
        },
       
        Populate: function (values, modalIdentifier) {
            modalIdentifier = typeof modalIdentifier === 'undefined' ? '#messages' : modalIdentifier;
            setModalValues(values, modalIdentifier);
        }
    }
})();